
















































import { Component, Vue } from 'vue-property-decorator';
import { BookingWizardModule } from '@/store/modules/bookingWizard';
import BookingDto from '@/models/Bookings/BookingDto';
import PageNames from '@/router/PageNames';
import GiganautVue from '@/components/Shared/GiganautVue';


@Component({
  name: 'BookingWizardComplete',
  components: {  }
})
export default class BookingWizardComplete extends GiganautVue {

  async navigateToBooking() {
    this.$router.push({ name: PageNames.AgencyBookingDetails, params: { bookingid: BookingWizardModule.newBooking.id } });
  }
}
